/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Apr 09 2024
 **/

import { sortedUniqBy } from "lodash-es";

const LOUNGE_INDEX = 0;

/**
 * @description
 * 1. 마이룸
 * 2. 오픈월드
 * 3. 최초 가입그룹 라운지
 * 4. 최초 가입그룹 ㄱ스페이스
 * 5. 최초 가입그룹 ㄴ스페이스
 * 6. 마지막 가입그룹 라운지
 * 7. 마지막 가입그룹 ㄱ스페이스
 * 8. 마지막 가입그룹 ㄴ스페이스
 */
export function prioritySortSpace(groups: WebServices.Space.MySpaces.List.Data["groups"]) {
	return (
		groups
			.sort((a, b) => a.spaces[LOUNGE_INDEX].createdTime - b.spaces[LOUNGE_INDEX].createdTime)
			.map((group) =>
				prioritySortLoungeType(group.spaces).map((item) => ({
					label: item.spaceType === "DEFAULT" ? group.name + " " + item.spaceName : item.spaceName || "",
					value: String(item.spaceId || ""),
					meta: "SPACE"
				}))
			)
			.flat() || []
	);

	function prioritySortLoungeType(array: WebServices.Space.MySpaces.List.Data["groups"][number]["spaces"]) {
		const item = array.find((item) => item.spaceType === "DEFAULT");
		if (!item) return [...sortedUniqBy(array, "spaceName")];

		const filteredItems = array.filter((item) => item.spaceType !== "DEFAULT");
		return [item, ...sortedUniqBy(filteredItems, "spaceName")];
	}
}
